module.exports = __webpack_public_path__ + "img/tratamento_gestao_stress.245d6650.jpg";